export * from "./multiRenderTarget.pure";
